import React from 'react'
import { SkeletonLoaderOverlayBox, SkeletonLoaderContainer } from './SkeletonLoaders.css'

interface OverlaySkeletonLoaderProps {
  padding?: string
}

const OverlaySkeletonLoader: React.FC<OverlaySkeletonLoaderProps> = ({ padding, children }) => (
  <SkeletonLoaderOverlayBox>
    <SkeletonLoaderContainer padding={padding}>
      {children}
    </SkeletonLoaderContainer>
  </SkeletonLoaderOverlayBox>
)

export default OverlaySkeletonLoader
